<template>
  <el-table
    :data="tableData"
    style="width: 100%">
    <el-table-column
      v-for="(item, index) in headers"
      :key="index"
      :prop="item.key"
      :show-overflow-tooltip="true"
      :label="item.label">
    </el-table-column>
  </el-table>
</template>
<script>
export default {
  props: {
    headers: {
      type: Array
    },
    tableData: {
      type: Array
    }
  },
  data() {
    return {};
  }
};
</script>
<style lang="scss" scoped>

</style>
